import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import { ROUTES } from '../../../../common/constants';
import AssignDeliveryPartner from './pages/AssignDeliveryPartner';
import New from './pages/New';

const NewWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES?.ORDERS}${ROUTES?.NEW}`}
      render={() => (
        <Redirect
          to={`${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.CONFIRM_ORDER}`}
        />
      )}
    />
    <Route
      exact
      path={`${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.CONFIRM_ORDER}`}
      render={(props) => <New {...props} />}
    />
    <Route
      exact
      path={`${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.ASSIGN_DELIVERY_PARTNER}`}
      render={(props) => <AssignDeliveryPartner {...props} />}
    />
  </Switch>
);

export default NewWrapper;
